import React from 'react';
import { AddPlantSourceForm } from './AddPlantSourceForm';
import { ResponsiveModal, ResponsiveModalBody } from '../ui';

interface AddPlantSourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (sourceId: string) => void;
}

export function AddPlantSourceModal({ isOpen, onClose, onSuccess }: AddPlantSourceModalProps) {
  const handleSuccess = (sourceId: string) => {
    if (onSuccess) {
      onSuccess(sourceId);
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} size="md">
      <ResponsiveModalBody>
        <AddPlantSourceForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </ResponsiveModalBody>
    </ResponsiveModal>
  );
}
